export default __webpack_public_path__ + "media/images/apartment_page/lighting_fast_wifi-043c2545fbee6726fffc983a68404ee8.jpg";